import {
    ICustomCellRendererParams,
    ProgramType,
    ProgramTypeText,
    SubModule,
} from "@/ts/common-types";
import { useDispatch } from "react-redux";
import {
    updateBiddingModalData,
    updateBiddingModalDisplay,
} from "@/features/modalSlice";
import { FaCirclePlus } from "react-icons/fa6";
import { useState } from "react";
import useGetModulesData from "@/hooks/useGetModulesData";
import { BiddingType, BiddingTypeConstants } from "@/ts/constants";
import { Popover } from "antd";

const BiddingCellRenderer = (params: ICustomCellRendererParams) => {
    const [isUIDisabled] = useState(
        [ProgramType.Awareness, ProgramType.Performance].includes(
            params.data.program_type
        )
    );
    const componentConfig = useGetModulesData({
        type: "component-config",
        activeModuleName: SubModule.CAMPAIGN,
    });
    const gridParams = useGetModulesData({
        type: "grid-params",
        activeModuleName: SubModule.CAMPAIGN,
    });

    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(updateBiddingModalDisplay(true));
        dispatch(updateBiddingModalData(params.data));
    };

    return (
        <div>
            {params.node.rowPinned ? null : (
                <Popover
                    className="mx-2"
                    content={
                        <div>
                            <div className="mb-3 pb-2 border-bottom">
                                <strong>Bidding Info</strong>
                            </div>
                            {gridParams.isCpmChangeAllowed &&
                                gridParams.cpmChangeAllowedTypes.includes(
                                    params.data.program_type
                                ) && (
                                    <div className="my-1">
                                    CPM: {params.data.cpm_bid}
                                    </div>
                                )}
                            {/* <Divider /> */}
                            {Object.entries(BiddingType)
                                .filter(
                                    ([key]) =>
                                        !componentConfig[
                                            key
                                        ]?.disabledTypes.includes(
                                            params.data.program_type
                                        ) &&
                                        !componentConfig[
                                            key
                                        ]?.disabledTypes.includes(
                                            params.data.targetingtype
                                        )
                                )
                                .map(([key]) => (
                                    <div key={key} className="my-1">
                                        {`${componentConfig[key]?.label}: ${
                                            key ===
                                            BiddingTypeConstants.PREMIUM_USERS
                                                ? params.data
                                                      .premium_placements_bid
                                                : key ===
                                                  BiddingTypeConstants.PRODUCT_LISTING_PAGE
                                                ? params.data.product_page_bid
                                                : params.data[`${key}_bid`]
                                        }`}
                                    </div>
                                ))}
                        </div>
                    }
                    styles={{
                        body: {
                            padding: "15px",
                            minWidth: "200px",
                        },
                    }}
                    placement="right"
                >
                    <FaCirclePlus
                        className="mt-2 ms-2"
                        onClick={handleClick}
                        style={{
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            ...(isUIDisabled
                                ? { pointerEvents: "none", color: "grey" }
                                : { color: "#0D6EFD" }),
                        }}
                    />
                </Popover>
            )}
        </div>
    );
};

export default BiddingCellRenderer;
